var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1165,
    viewBox: "0 0 1920 1165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_692_54",
    x: -201.793,
    y: 0,
    width: 2385.79,
    height: 1165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_692_54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_54",
    x1: -2,
    y1: 451,
    x2: 1918,
    y2: 451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A4B"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_692_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513 253H791.987V266H1082.02V325H1415.08V413H1684.56V532H1961.56V723H1984V965H1860V774H1616V673H1339V611H982.084V566H737.016V537H446.987V493H167V485H-1.79297V226H167V200H513V253Z",
    fill: "url(#paint0_linear_692_54)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "                 0,0;                 -80,15;                 30,-10;                 60,20;                 -90,-15;                 -20,10;                 70,-20;                 40,25;                 -60,5;                 0,0",
    dur: "8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M513 253H791.987V266H1082.02V325H1415.08V413H1684.56V532H1961.56V723H1984V965H1860V774H1616V673H1339V611H982.084V566H737.016V537H446.987V493H167V485H-1.79297V226H167V200H513V253Z",
    fill: "url(#paint0_linear_692_54)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "                 0,0;                 90,-20;                 -40,15;                 -70,-10;                 110,25;                 30,-15;                 -80,10;                 -50,-25;                 60,20;                 0,0",
    dur: "9s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M513 253H791.987V266H1082.02V325H1415.08V413H1684.56V532H1961.56V723H1984V965H1860V774H1616V673H1339V611H982.084V566H737.016V537H446.987V493H167V485H-1.79297V226H167V200H513V253Z",
    fill: "url(#paint0_linear_692_54)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "                 0,0;                 -60,25;                 80,-15;                 -30,-20;                 50,10;                 -90,30;                 40,-25;                 70,15;                 -50,-10;                 0,0",
    dur: "10s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryFaq);
export default __webpack_public_path__ + "static/media/category_faq.5f2081cd40bb6e7b7d9aceac4246e565.svg";
export { ForwardRef as ReactComponent };